import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Checkbox extends Component {

    render() {
        return (
            <div className="custom-cb-container">
                <span onClick={() => {
                    this.props.handleCheckboxes()
                }}>
                    <input readOnly className="custom-cb" type="checkbox" checked={this.props.checked} />
                    <span></span>
                </span>

                <label htmlFor="data"
                    onClick={() => {
                        this.props.handleCheckboxes()
                    }}>
                    {this.props.label}
                </label>
            </div>
        )
    }
}

Checkbox.propTypes = {
    handleCheckboxes: PropTypes.func.isRequired,
    label: PropTypes.string,
    checked: PropTypes.bool
};

export default Checkbox;


// WEBPACK FOOTER //
// ./src/components/checkbox.js